import { create } from 'zustand';

export type ToastTone = 'neutral' | 'success' | 'error';

export interface Toast {
  id: string;
  message: string;
  tone: ToastTone;
}

interface ToastState {
  toasts: Toast[];
  push: (message: string, tone?: ToastTone) => void;
  dismiss: (id: string) => void;
}

const DISMISS_AFTER_MS = 4500;

export const useToasts = create<ToastState>((set, get) => ({
  toasts: [],

  push: (message, tone = 'neutral') => {
    const id = crypto.randomUUID();
    set((state) => ({ toasts: [...state.toasts, { id, message, tone }] }));
    window.setTimeout(() => get().dismiss(id), DISMISS_AFTER_MS);
  },

  dismiss: (id) => set((state) => ({ toasts: state.toasts.filter((t) => t.id !== id) })),
}));

/** Convenience wrapper so call sites do not need the hook. */
export const toast = {
  info: (message: string) => useToasts.getState().push(message, 'neutral'),
  success: (message: string) => useToasts.getState().push(message, 'success'),
  error: (message: string) => useToasts.getState().push(message, 'error'),
};
